import { useState } from 'react';
import { genProxyV2Resource } from 'utilities/api';

const useInventoryV2Api = resourceName => {
  const [api] = useState(genProxyV2Resource(resourceName));

  return api;
};

export default useInventoryV2Api;
